
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kwT2K", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f966ef4170f87364$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $f966ef4170f87364$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': "Seu hist\xf3rico de bate-papo \xe9 salvo por at\xe9 30 dias.",
    'ai-mate.chat-error-banner.title': 'Iniciar novo bate-papo',
    'ai-mate.chat-error.description': 'Tente <btn>recarregar o bate-papo</btn>.',
    'ai-mate.chat-error.rate-limited-description': "Voc\xea atingiu o n\xfamero m\xe1ximo de solicita\xe7\xf5es. Tente de novo mais tarde.",
    'ai-mate.chat-error.rate-limited-title': "Muitas solicita\xe7\xf5es",
    'ai-mate.chat-error.rovo-inactive-description': "Parece que o Rovo n\xe3o est\xe1 habilitado no site. <link>Configurar o Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': "O Rovo est\xe1 inativo",
    'ai-mate.chat-error.title': "A gente n\xe3o sabe o que deu errado",
    'ai-mate.main-chat.close-chat-button-label': 'Fechar',
    'ai-mate.main-chat.maximize-chat-button-label': 'Tela cheia',
    'ai-mate.main-chat.minimize-chat-button-label': "Restaurar visualiza\xe7\xe3o",
    'ai-mate.main-chat.new-chat-button-label': 'Novo',
    'ai-mate.main-chat.new-chat-button-label-full-screen': 'Novo bate-papo',
    'conversation-assistant-button.label': 'Bate-papo',
    'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Enviar',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pergunte ao Atlassian Intelligence sobre isso',
    'highlight-actions.rovo-chat-explain-option.text': 'Explique',
    'highlight-actions.rovo-chat-explain-prompt': "Explique isso parafraseando e incluindo mais informa\xe7\xf5es, mas utilizando uma linguagem bem simples, frases curtas e dando exemplos e defini\xe7\xf5es para qualquer terminologia t\xe9cnica utilizada na frase original.",
    'highlight-actions.rovo-chat-find-resources-option.text': 'Procurar recursos',
    'highlight-actions.rovo-chat-find-resources-prompt': "Descubra recursos apenas com conhecimentos organizacionais que corroborem com a declara\xe7\xe3o feita.",
    'highlight-actions.rovo-chat-give-examples-option.text': "D\xea exemplos",
    'highlight-actions.rovo-chat-give-examples-prompt': "D\xea exemplos disto em recursos organizacionais ou conhecimento p\xfablico. Se n\xe3o houver recursos para oferecer, tente fazer uma met\xe1fora para exemplificar e ajudar algu\xe9m a entender melhor.",
    'highlight-actions.rovo-chat-give-feedback-option.text': 'Enviar feedback',
    'highlight-actions.rovo-chat-give-feedback-prompt': "D\xea feedback analisando a formula\xe7\xe3o disto. Fa\xe7a coment\xe1rios sobre a escolha de palavras, a gram\xe1tica e a pontua\xe7\xe3o. Seja positivo e empolgado, mas sempre aponte pelo menos uma coisa que precisa ser melhorada ou alterada.",
    'highlight-actions.rovo-chat-more-options.tooltip': "Recomenda\xe7\xf5es de bate-papo",
    'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir bate-papo',
    'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
    'highlight-actions.rovo-chat-summarize-prompt': "Destaque os principais pontos disto. Foque em informa\xe7\xf5es essenciais e descarte dados desnecess\xe1rios. Ofere\xe7a uma vis\xe3o geral concisa em um \xfanico par\xe1grafo.",
    'highlight-actions.rovo-chat.button-text': 'Bate-papo',
    'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Pergunte no chat',
    'horizontal-scroll-container.scroll-left': 'Rolar para a esquerda',
    'horizontal-scroll-container.scroll-right': 'Rolar para a direita'
};

});


//# sourceMappingURL=pt_BR.00c2435f.js.map
